import { Box, Button, IconButton, Stack, TextField, Typography } from "@mui/material";
import { GiftItem, userState } from "../../../../interface/MainInterface";
import PopUploadImageViaApi from "./PopUploadImageViaApi";
import { useRef } from "react";

interface PropsType {
  userState: userState;
  index: number;
  gift: GiftItem;
  onChange: (index: number, updated: Partial<GiftItem>) => void;
  onDelete: (index: number) => void;
}

const GiftItemForm = ({ userState, index, gift, onChange, onDelete }: PropsType) => {
  const popUploadImageRef: any = useRef();

  // 경품 이미지 업로드
  const upload_gift_image = async () => {
    popUploadImageRef.current.open();
  };

  return (
    <>
      <Stack
        spacing={2}
        sx={{
          border: "1px solid #ddd",
          borderRadius: 2,
          p: 2,
          bgcolor: "#fafafa",
        }}
      >
        {/* 상단 헤더 */}
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography fontWeight={700}>경품 #{index + 1}</Typography>
          {index > 0 && (
            <IconButton onClick={() => onDelete(index)} size="small">
              🗑
            </IconButton>
          )}
        </Stack>

        {/* 경품명 */}
        <TextField
          label="경품명"
          value={gift.ofrNm}
          size="small"
          fullWidth
          onChange={(e) => onChange(index, { ofrNm: e.target.value })}
        />

        {/* 경품 수량 */}
        <TextField
          label="경품수량"
          type="number"
          value={gift.offrQty}
          size="small"
          fullWidth
          inputProps={{
            min: 0,
          }}
          onChange={(e) => onChange(index, { offrQty: Number(e.target.value) })}
        />

        {/* 이미지 + 업로드 버튼 */}
        <Stack spacing={2} sx={{ width: 120 }}>
          <Box
            component="img"
            src={gift.imgPath ? gift.imgPath : "/images/upload.png"}
            alt="경품"
            sx={{
              width: 120,
              height: 120,
              objectFit: "cover",
              borderRadius: 2,
              border: "1px solid #ddd",
            }}
          />

          <Button variant="contained" size="small" onClick={upload_gift_image}>
            경품 이미지 업로드
          </Button>
        </Stack>
      </Stack>
      <PopUploadImageViaApi
        ref={popUploadImageRef}
        userState={userState}
        callback={(payload: any) => {
          if (payload.command === "upload_finish") {
            onChange(index, { imgPath: payload.key });
          }
        }}
      />
    </>
  );
};

export default GiftItemForm;
